// import React from 'react';
// import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaCcVisa, FaCcMastercard, FaCcPaypal } from 'react-icons/fa';
// import { Link } from 'react-router-dom';

// const Footer = () => {
//   // Color palette
//   const colors = {
//     primary: '#1C1C1E',       // Deep Charcoal
//     secondary: '#D4AF37',     // Gold Accent
//     background: '#F5F5F5',    // Off White
//     text: '#0D0D0D',          // Rich Black
//     cta: '#2C3E50',           // Midnight Blue
//     hoverGold: '#CFAF24',      // Gold Hover
//     white: '#FFFFFF',
//     lightGray: '#E5E5EA',
//     darkGray: '#8E8E93'
//   };

//   return (
//     <footer style={{
//       backgroundColor: colors.primary,
//       color: colors.white,
//       padding: '50px 15px 25px',
//       marginTop: '50px',
//       fontFamily: "'Montserrat', sans-serif"
//     }}>
//       <div style={{
//         maxWidth: '1200px',
//         margin: '0 auto',
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
//         gap: '30px',
//         marginBottom: '30px'
//       }}>
//         {/* Brand Column - Smaller */}
//         <div style={{
//           display: 'flex',
//           flexDirection: 'column'
//         }}>
//           <h3 style={{
//             fontFamily: "'Playfair Display', serif",
//             fontSize: '1.3rem',
//             marginBottom: '15px',
//             fontWeight: '500',
//             color: colors.secondary
//           }}>
//             SURYAWANSHI OPTICS
//           </h3>
//           <p style={{
//             fontSize: '0.8rem',
//             color: colors.lightGray,
//             lineHeight: '1.5',
//             marginBottom: '15px'
//           }}>
//             Premium eyewear and optical solutions featuring top brands like Titan, Timex, and Crizal.
//           </p>
//           <div style={{
//             display: 'flex',
//             gap: '8px',
//             marginBottom: '15px',
//             flexDirection: 'row'
//           }}>
//             <a href="#" style={{ 
//               color: colors.lightGray, 
//               transition: 'color 0.3s ease',
//               display: 'flex',
//               flexDirection: 'column'
//             }}
//               onMouseEnter={(e) => e.currentTarget.style.color = colors.secondary}
//               onMouseLeave={(e) => e.currentTarget.style.color = colors.lightGray}>
//               <FaFacebook style={{
//                 display: 'flex',
//                 width: '100%',
//                 flexGrow: '0',
//                 flexDirection: 'column',
//                 alignSelf: 'stretch'
//               }} size={16} />
//             </a>
//             <a href="#" style={{ 
//               color: colors.lightGray, 
//               transition: 'color 0.3s ease',
//               display: 'flex',
//               flexDirection: 'column'
//             }}
//               onMouseEnter={(e) => e.currentTarget.style.color = colors.secondary}
//               onMouseLeave={(e) => e.currentTarget.style.color = colors.lightGray}>
//               <FaTwitter style={{
//                 display: 'flex',
//                 width: '100%',
//                 flexGrow: '0',
//                 flexDirection: 'column',
//                 alignSelf: 'stretch'
//               }} size={16} />
//             </a>
//             <a href="#" style={{ 
//               color: colors.lightGray, 
//               transition: 'color 0.3s ease',
//               display: 'flex',
//               flexDirection: 'column'
//             }}
//               onMouseEnter={(e) => e.currentTarget.style.color = colors.secondary}
//               onMouseLeave={(e) => e.currentTarget.style.color = colors.lightGray}>
//               <FaInstagram style={{
//                 display: 'flex',
//                 width: '100%',
//                 flexGrow: '0',
//                 flexDirection: 'column',
//                 alignSelf: 'stretch'
//               }} size={16} />
//             </a>
//             <a href="#" style={{ 
//               color: colors.lightGray, 
//               transition: 'color 0.3s ease',
//               display: 'flex',
//               flexDirection: 'column'
//             }}
//               onMouseEnter={(e) => e.currentTarget.style.color = colors.secondary}
//               onMouseLeave={(e) => e.currentTarget.style.color = colors.lightGray}>
//               <FaLinkedin style={{
//                 display: 'flex',
//                 width: '100%',
//                 flexGrow: '0',
//                 flexDirection: 'column',
//                 alignSelf: 'stretch'
//               }} size={16} />
//             </a>
//           </div>
//         </div>

//         {/* Quick Links Column - Smaller */}
//         <div>
//           <h4 style={{
//             fontFamily: "'Playfair Display', serif",
//             fontSize: '1rem',
//             marginBottom: '15px',
//             fontWeight: '500',
//             color: colors.white
//           }}>
//             Quick Links
//           </h4>
//           <ul style={{
//             listStyle: 'none',
//             padding: 0,
//             margin: 0,
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '8px'
//           }}>
//             {[
//               { name: 'Home', path: '/' },
//               { name: 'Collections', path: '/products' },
//               { name: 'Watches', path: '/watches' },
//               { name: 'Sunglasses', path: '/sunglasses' },
//               { name: 'Clocks', path: '/accessories' },
//             ].map((link) => (
//               <li key={link.name} style={{
//                 width: '100%',
//                 alignSelf: 'stretch'
//               }}>
//                 <Link 
//                   to={link.path}
//                   style={{
//                     fontSize: '0.8rem',
//                     color: colors.lightGray,
//                     textDecoration: 'none',
//                     transition: 'all 0.3s ease',
//                     width: '100%',
//                     alignSelf: 'stretch'
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.color = colors.secondary;
//                     e.currentTarget.style.paddingLeft = '4px';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.color = colors.lightGray;
//                     e.currentTarget.style.paddingLeft = '0';
//                   }}
//                 >
//                   {link.name}
//                 </Link>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Customer Service Column - Smaller */}
//         <div>
//           <h4 style={{
//             fontFamily: "'Playfair Display', serif",
//             fontSize: '1rem',
//             marginBottom: '15px',
//             fontWeight: '500',
//             color: colors.white
//           }}>
//             Customer Service
//           </h4>
//           <ul style={{
//             listStyle: 'none',
//             padding: 0,
//             margin: 0,
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '8px'
//           }}>
//             {[
//               { name: 'Shipping Policy', path: '/ShippingPolicy' },
//               { name: 'Returns & Exchanges', path: '/ReturnsExchanges' }
//             ].map((item) => (
//               <li key={item.name} style={{
//                 width: '100%',
//                 alignSelf: 'stretch'
//               }}>
//                 <Link 
//                   to={item.path}
//                   style={{
//                     fontSize: '0.8rem',
//                     color: colors.lightGray,
//                     textDecoration: 'none',
//                     transition: 'all 0.3s ease',
//                     width: '100%',
//                     alignSelf: 'stretch'
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.color = colors.secondary;
//                     e.currentTarget.style.paddingLeft = '4px';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.color = colors.lightGray;
//                     e.currentTarget.style.paddingLeft = '0';
//                   }}
//                 >
//                   {item.name}
//                 </Link>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Contact Column - Smaller */}
//         <div>
//           <h4 style={{
//             fontFamily: "'Playfair Display', serif",
//             fontSize: '1rem',
//             marginBottom: '15px',
//             fontWeight: '500',
//             color: colors.white
//           }}>
//             Contact Us
//           </h4>
//           <address style={{
//             fontStyle: 'normal',
//             fontSize: '0.8rem',
//             color: colors.lightGray,
//             lineHeight: '1.5',
//             marginBottom: '15px'
//           }}>
//             Station Road, Near Rajwada<br />
//             Tasgaon 416312, (Sangli)<br />
//             India<br />
//             <br />
//             Email: info@suryawanshioptics.com<br />
//             Phone: +91 79729 64344
//           </address>
//         </div>
//       </div>

//       {/* Copyright - Smaller */}
//       <div style={{
//         maxWidth: '1200px',
//         margin: '0 auto',
//         borderTop: `1px solid ${colors.darkGray}`,
//         paddingTop: '20px',
//         textAlign: 'center'
//       }}>
//         <p style={{
//           fontSize: '0.7rem',
//           color: colors.darkGray,
//           margin: 0
//         }}>
//           © {new Date().getFullYear()} Suryawanshi Optics. All rights reserved.
//         </p>
//         <div style={{
//           display: 'flex',
//           justifyContent: 'center',
//           gap: '15px',
//           marginTop: '10px'
//         }}>
//           <a href="/PrivacyPolicy" style={{
//             fontSize: '0.7rem',
//             color: colors.darkGray,
//             textDecoration: 'none',
//             transition: 'color 0.3s ease'
//           }}
//           onMouseEnter={(e) => e.currentTarget.style.color = colors.secondary}
//           onMouseLeave={(e) => e.currentTarget.style.color = colors.darkGray}>
//             Privacy Policy
//           </a>        
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaCcVisa, FaCcMastercard, FaCcPaypal, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = () => {
  // Color palette
  const colors = {
    primary: '#24243e',       // Dark background
    secondary: '#d4af37',     // Gold accent
    accent: '#2c3e50',        // Blue accent
    text: '#f5f5f5',          // Light text
    lightText: '#e0e0e0',     // Secondary text
    darkText: '#333333',      // Dark text
    border: '#3a3a3a',        // Border color
    hoverGold: '#c9a227',     // Gold hover
    white: '#ffffff',
    lightGray: '#e5e5e5',
    darkGray: '#8e8e93'
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <motion.footer 
      initial="hidden"
      animate="visible"
      variants={containerVariants}
      style={{
        backgroundColor: colors.primary,
        color: colors.text,
        padding: '60px 20px 30px',
       
        fontFamily: "'Poppins', sans-serif",
        boxShadow: '0 -5px 15px rgba(0,0,0,0.1)'
      }}
    >
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '40px',
        marginBottom: '40px'
      }}>
        {/* Brand Column */}
        <motion.div variants={itemVariants} style={{
          display: 'flex',
          flexDirection: 'column'
        }}>
          <h3 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '1.5rem',
            marginBottom: '20px',
            fontWeight: '600',
            color: colors.secondary,
            letterSpacing: '1px'
          }}>
            SURYAWANSHI WATCH & OPTICIANS
          </h3>
          <p style={{
            fontSize: '0.9rem',
            color: colors.lightText,
            lineHeight: '1.6',
            marginBottom: '20px'
          }}>
            Premium eyewear and optical solutions featuring top brands like Titan, Timex, and Crizal.
          </p>
         
        </motion.div>

        {/* Quick Links Column */}
        <motion.div variants={itemVariants}>
          <h4 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '1.2rem',
            marginBottom: '20px',
            fontWeight: '500',
            color: colors.white,
            position: 'relative',
            paddingBottom: '10px'
          }}>
            Quick Links
            <span style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '50px',
              height: '2px',
              backgroundColor: colors.secondary
            }}></span>
          </h4>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
          }}>
            {[
              { name: 'Home', path: '/' },
              { name: 'Collections', path: '/products' },
              { name: 'Watches', path: '/watches' },
              { name: 'Sunglasses', path: '/sunglasses' },
              { name: 'Clocks', path: '/accessories' },
              { name: 'Contact Us', path: '/ContactUs' }
            ].map((link, index) => (
              <motion.li 
                key={link.name}
                variants={itemVariants}
                whileHover={{ x: 5 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <Link 
                  to={link.path}
                  style={{
                    fontSize: '0.9rem',
                    color: colors.lightText,
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <span style={{
                    display: 'inline-block',
                    width: '6px',
                    height: '6px',
                    backgroundColor: colors.secondary,
                    borderRadius: '50%',
                    marginRight: '10px',
                    transition: 'all 0.3s ease'
                  }}></span>
                  {link.name}
                </Link>
              </motion.li>
            ))}
          </ul>
        </motion.div>

        {/* Customer Service Column */}
        <motion.div variants={itemVariants}>
          <h4 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '1.2rem',
            marginBottom: '20px',
            fontWeight: '500',
            color: colors.white,
            position: 'relative',
            paddingBottom: '10px'
          }}>
            Customer Service
            <span style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '50px',
              height: '2px',
              backgroundColor: colors.secondary
            }}></span>
          </h4>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
          }}>
            {[
              { name: 'Shipping Policy', path: '/ShippingPolicy' },
              { name: 'Returns & Exchanges', path: '/ReturnsExchanges' },
              { name: 'Privacy Policy', path: '/PrivacyPolicy' },
              { name: 'Cancellation Policy', path: '/CancellationPolicy' },
              { name: 'Terms & Conditions', path: '/TermsAndConditions' }

            ].map((item, index) => (
              <motion.li 
                key={item.name}
                variants={itemVariants}
                whileHover={{ x: 5 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <Link 
                  to={item.path}
                  style={{
                    fontSize: '0.9rem',
                    color: colors.lightText,
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <span style={{
                    display: 'inline-block',
                    width: '6px',
                    height: '6px',
                    backgroundColor: colors.secondary,
                    borderRadius: '50%',
                    marginRight: '10px',
                    transition: 'all 0.3s ease'
                  }}></span>
                  {item.name}
                </Link>
              </motion.li>
            ))}
          </ul>
        </motion.div>

        {/* Contact Column */}
        <motion.div variants={itemVariants}>
          <h4 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '1.2rem',
            marginBottom: '20px',
            fontWeight: '500',
            color: colors.white,
            position: 'relative',
            paddingBottom: '10px'
          }}>
            Contact Us
            <span style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '50px',
              height: '2px',
              backgroundColor: colors.secondary
            }}></span>
          </h4>
          <address style={{
            fontStyle: 'normal',
            fontSize: '0.9rem',
            color: colors.lightText,
            lineHeight: '1.8'
          }}>
            <motion.div 
              variants={itemVariants}
              style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '15px' }}
            >
              <FaMapMarkerAlt style={{ 
                color: colors.secondary, 
                fontSize: '1rem', 
                marginRight: '10px',
                marginTop: '3px'
              }} />
              <div>
                Station Road, Near Rajwada<br />
                Tasgaon 416312, (Sangli)<br />
                India
              </div>
            </motion.div>
            
            <motion.div 
              variants={itemVariants}
              style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}
            >
              <FaEnvelope style={{ 
                color: colors.secondary, 
                fontSize: '1rem', 
                marginRight: '10px'
              }} />
              <a href="mailto:suryawanshiwatch1918@gmail.com" style={{
                color: colors.lightText,
                textDecoration: 'none',
                transition: 'color 0.3s ease'
              }}>
                suryawanshiwatch1918@gmail.com
              </a>
            </motion.div>
            
            <motion.div 
              variants={itemVariants}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <FaPhone style={{ 
                color: colors.secondary, 
                fontSize: '1rem', 
                marginRight: '10px'
              }} />
              <a href="tel:+917972964344" style={{
                color: colors.lightText,
                textDecoration: 'none',
                transition: 'color 0.3s ease'
              }}>
                +91 79729 64344
              </a>
            </motion.div>
          </address>
        </motion.div>
      </div>

      {/* Payment Methods and Copyright */}
      <motion.div 
        variants={itemVariants}
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          borderTop: `1px solid ${colors.border}`,
          paddingTop: '30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
          marginBottom: '20px',
          flexWrap: 'wrap'
        }}>
          {[
            { icon: <FaCcVisa size={28} />, name: 'Visa' },
            { icon: <FaCcMastercard size={28} />, name: 'Mastercard' },
            { icon: <FaCcPaypal size={28} />, name: 'PayPal' }
          ].map((method, index) => (
            <motion.div
              key={index}
              whileHover={{ y: -3 }}
              style={{
                color: colors.lightText,
                transition: 'all 0.3s ease'
              }}
              aria-label={method.name}
            >
              {method.icon}
            </motion.div>
          ))}
        </div>
        
        <p style={{
          fontSize: '0.8rem',
          color: colors.darkGray,
          margin: '0 0 10px',
          textAlign: 'center'
        }}>
          © {new Date().getFullYear()} Suryawanshi Watch & Opticians. All rights reserved.
        </p>
        
      </motion.div>
    </motion.footer>
  );
};

export default Footer;